import { useCallback } from 'react';
import { useGetLayoutStylesParams } from 'root/hooks/useGetLayoutStylesParams';
import type { PopulatedMenu } from 'root/apiTypes';
import type { NavigateToFn, NavigateToParams } from 'root/clientTypes';
import { useGetNavigationLayout } from 'root/hooks/preset/useGetNavigationLayout';
import type { ILocation } from '@wix/yoshi-flow-editor';
import { useNavigationBi } from 'root/components/Menus/Navigation/Navigation.bi';
import { MenuNavigationObject } from 'root/consts';

type UseSharedNavigationLogicParams = {
  menus: PopulatedMenu[];
  setActiveItem: (index: number) => void;
  navigateTo: NavigateToFn;
  currentUrl: ILocation['url'];
};

export const useSharedNavigationLogic = ({
  menus,
  setActiveItem,
  navigateTo,
  currentUrl,
}: UseSharedNavigationLogicParams) => {
  const { preset } = useGetLayoutStylesParams();
  const { reportMenuNavigationClick } = useNavigationBi();

  const navigationLayout = useGetNavigationLayout(preset);

  const getMenuNavigationDetailsByIndex = useCallback(
    (index: number): NavigateToParams => {
      const menu = menus[index];
      const menuId = menu.id;
      const locationName = menu.businessLocationDetails?.name ?? '';
      const urlQueryParam = menu.urlQueryParam;
      return { currentUrl, menuId, urlQueryParam, isFirst: index === 0, locationName };
    },
    [currentUrl, menus]
  );

  const selectMenu = (index: number) => {
    const menu = getMenuNavigationDetailsByIndex(index);
    setActiveItem(index);
    navigateTo(menu);
    reportMenuNavigationClick({
      navigationLayout,
      numMenus: menus.length,
      object: MenuNavigationObject.Menu,
    });
  };
  return {
    getMenuNavigationDetailsByIndex,
    selectMenu,
  };
};
